import React from 'react';
import { FormLogin } from './FormLogin';

const Login = () => {
  // const [register, setRegister] = React.useState(false);

  return (
    <div>
      <FormLogin />
    </div>
  )
}

export { Login };
